export default {
  root: {
    '&$expanded': {
      margin: 0,
    },
  },
};
